module.exports = __webpack_public_path__ + "static/media/catalogue-ru.d2962b8a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/docs/catalogue-ru.pdf
// module id = 726
// module chunks = 0